import { Component, EventEmitter, Output, Input } from '@angular/core';
import {Common} from '../../shared/common';
import { UserData } from '../../models/UserData';

@Component({
  selector: 'added-user-popup',
  templateUrl: './added-user-popup.component.html',
  styleUrls: ['./added-user-popup.component.less', '../../shared/common.less']
})
export class AddedUserPopupComponent {
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  @Input() contactAdded: UserData | null = null;

  constructor(public common: Common) {}

  onDismiss(event: boolean) {
    this.endDetailsPopup.emit(event);
  }

  defineRole(profile: number): string {
    switch (profile) {
      case 0:
        return "RH";
      case 1:
        return "BV";
      case 2:
        return "SC";
      case 3:
        return "CP";
      default:
        return "";
    }
  }

  getRoleBackgroundColor(profile: number): string {
    switch (profile) {
      case 0:
        return "#D8E8FF";
      case 1:
        return "#CBFFD5";
      case 2:
        return "#E8EDF3";
      case 3:
        return "#FDE7F3";
      default:
        return "#FFFFFF";
    }
  }

  defineFullRole(profile: number): string {
    switch (profile) {
      case 0:
        return "Ressources humaines";
      case 1:
        return "Bureau de vote";
      case 2:
        return "Scrutateur";
      case 3:
        return "Chef de projet";
      default:
        return "";
    }
  }

  ngOnInit() {}
}
